export const HorizontalDivider = ({ className }) => {
    return (<div className={`divide-y-[1px] divide-white/10 ${className}`}>
      <div></div>
      <div></div>
    </div>);
};
